import { GuidanceBox, Text } from '@betterment/samba-react';

import MessageCta from './message-cta';

import { Message } from '../../../graphql/schema';

interface MessageGuidanceBoxProps {
  message: Message;
  handleCloseMessage: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const MessageGuidanceBox: React.FC<MessageGuidanceBoxProps> = ({ message, handleCloseMessage }) => {
  const variant = message.title ? 'a' : 'b';

  return (
    <GuidanceBox variant={variant} css={{ maxWidth: 'none' }}>
      <GuidanceBox.Icon />
      {!!message.title && <GuidanceBox.Header>{message.title}</GuidanceBox.Header>}
      {message.isDismissible && <GuidanceBox.Close onClick={handleCloseMessage} />}
      <GuidanceBox.Content>
        <Text variant="text100">
          {message.body}
          {message.cta && <MessageCta cta={message.cta} />}
        </Text>
      </GuidanceBox.Content>
    </GuidanceBox>
  );
};

export default MessageGuidanceBox;
